import cx from 'classnames';
import React from 'react';
/**
 * Popover
 * Base component intended for consumption by Tooltip, Dropdown, Menu, etc. Only intended for direct use by consumers if they're building a custom component that behaves similarly to one of the above.
 * - Expects to be wrapped in a PopoverContainer which controls anchor side
 * - Expects to be used in conjunction with usePopoverState which controls behavior
 */
export const Popover = ({ align, open, popoverRef, children, className, ...rest }) => (React.createElement("div", { className: cx('tds-popover', {
        [`tds-popover--align-${align}`]: align,
        'tds-popover--open': open,
    }, className), ref: popoverRef, ...rest }, children));
